import { Table, Typography } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit } from "../../../../../../utils/helper/constants";
import { changeLoader } from "../../../../../../redux/reducers/loader";
import { useNavigate } from "react-router-dom";
import { roundToDecimal } from "../../../../../../utils/helper/utils";

const SalesByCustomer = ({ inputData, tabIndex }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [paginationModel] = useState(paginationLimit); //setPaginationModel
  const [dataSource, setDataSource] = useState([]);

  const getAllReportsByCustomer = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_CUSTOMER, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.data?.status === "SUCCESS") {
        if (apiResponse?.data?.data?.data) {
          let resultData = [];
          for (let key in apiResponse?.data?.data?.data) {
            let item = apiResponse?.data?.data?.data[key];
            resultData.push({
              key: key,
              // firstName: '',
              // lastName: '',
              // email: '',
              userMobileNo: item.userMobileNo,
              totalOrders: item.totalOrders,
              totalSalesWithTax: roundToDecimal(item.totalSalesWithTax, 2),
              salesWithoutTax: roundToDecimal(item.salesWithoutTax, 2),
              orders: [],
            });
          }
          setDataSource(resultData);
        }
        // setTotalRows(apiResponse?.data?.itemCount);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllReportsByCustomer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const columns = [
    {
    title: "ID",
    dataIndex: "id",
    key: "id",
    sorter: (a, b) => a.id - b.id,
    render: (text) => text || "-"
  },
    {
      title: "MobileNo",
      dataIndex: "userMobileNo",
      key: "UserMobileNo",
    },
    {
      title: "Total Orders",
      dataIndex: "totalOrders",
      key: "TotalOrders",
      // render: (text, record) => <Link to="/customer-order">{text}</Link>,
      render: (text, record) => (
        <Typography
          onClick={() => {
            navigate(`/customer-order/${record?.userMobileNo}`, {
              state: { inputData: inputData, tabIndex: tabIndex },
            });
          }}
          className="cursor-pointer text-[#176B53]"
        >
          {text}
        </Typography>
      ),
    },
    {
      title: "Total Sales With Tax",
      dataIndex: "totalSalesWithTax",
      key: "TotalSalesTax",
    },
    {
      title: "Total Sales Without Tax",
      dataIndex: "salesWithoutTax",
      key: "TotalSalesWithoutTax",
    },
  ];

  return <Table columns={columns} dataSource={dataSource} className="multi-tables responsive" />;
};

export default SalesByCustomer;
